var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"admin-dashboard-layout"}},[_c('Header'),_c('div',{staticClass:"center-container"},[_c('DashboardNav',{staticClass:"nav"}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }